import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Paper, TextField, Typography, CircularProgress } from "@mui/material";
import mapImg from "../assets/New_Map.png";
import logoImg from "../assets/skyovi-logo.png";
import idLogo from "../assets/IntelliDropLogo-new.png";
import { backendRoot } from "../config";

function ClientLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${backendRoot}/api/client-login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Login failed. Please try again.");
        return;
      }
      localStorage.setItem("clientToken", "true");
      localStorage.setItem("clientName", data.name);
      localStorage.setItem("clientEmail", data.email);
      localStorage.setItem("allowedProjects", JSON.stringify(data.allowed_projects));
      navigate("/projects");
    } catch (err) {
      setError("Unable to connect. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", background: "#faf9f6" }}>
      <Box
        sx={{
          flex: 1,
          backgroundImage: `url(${mapImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: { xs: "none", md: "block" },
        }}
      />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#fff",
          px: 4,
        }}
      >
        <Paper
          elevation={0}
          sx={{ width: "100%", maxWidth: 500, p: 6, boxShadow: "none", bgcolor: "transparent" }}
        >
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 0 }}>
            <Box component="img" src={logoImg} alt="brightspeed" sx={{ height: 80 }} />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 3 }}>
            <Box component="img" src={idLogo} alt="IntelliDrop" sx={{ height: 80, maxWidth: "100%" }} />
          </Box>
          <Typography variant="h6" fontWeight={700} align="center" sx={{ mb: 3, color: "#172033" }}>
            Client Portal Login
          </Typography>
          {error && (
            <Typography color="error" sx={{ mb: 2 }} align="center">
              {error}
            </Typography>
          )}
          <Box component="form" onSubmit={handleLogin} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
              autoFocus
              size="small"
            />
            <TextField
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              fullWidth
              size="small"
            />
            <Button
              variant="contained"
              type="submit"
              fullWidth
              disabled={loading}
              sx={{
                background: "#22577A",
                color: "#fff",
                fontWeight: 600,
                fontSize: "1rem",
                mt: 1,
                mb: 1,
                "&:hover": { background: "#1B4863" },
                borderRadius: 1,
                py: 1.5,
              }}
            >
              {loading ? <CircularProgress size={22} sx={{ color: "#fff" }} /> : "Login"}
            </Button>
            <Button
              variant="text"
              fullWidth
              onClick={() => navigate("/")}
              sx={{ color: "#667085", textTransform: "none" }}
            >
              Back to SSO Login
            </Button>
          </Box>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4 }}>
            Copyright © 2025 | Skyovi
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}

export default ClientLogin;
